import script from "./Programme.vue?vue&type=script&setup=true&lang=js"
export * from "./Programme.vue?vue&type=script&setup=true&lang=js"

import "./Programme.vue?vue&type=style&index=0&id=22999540&lang=css"

const __exports__ = script;

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTimeline from 'quasar/src/components/timeline/QTimeline.js';
import QTimelineEntry from 'quasar/src/components/timeline/QTimelineEntry.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QSpinnerClock from 'quasar/src/components/spinner/QSpinnerClock.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QBtn,QTimeline,QTimelineEntry,QIcon,QInput,QSelect,QSpinnerClock,QTooltip});qInstall(script, 'directives', {ClosePopup});
